// extracted by mini-css-extract-plugin
export default {"form":"RegisterFormStep_form__kJJZP"};